import { Bar } from '@nivo/bar';
import { Flex, Typography } from 'antd';
import { AutoSizer } from 'react-virtualized';
import _ from 'lodash';
import React from 'react';

interface IRenderedBarChart {
	rows?: string;
	xAxisKey?: string;
	yAxisKey?: string;
	title?: string;
}


export default function RenderedBarChart({ rows, title, xAxisKey, yAxisKey, }:IRenderedBarChart) {
    
	const data = React.useMemo(() => {
		try {
			const _rows = JSON.parse(rows ?? '') as ({[key: string]: string | number })[];

			if(!_rows) return [];
			if(!xAxisKey || !yAxisKey) return [];
			if(!Object.keys(_rows?.at(0) ?? {}).includes(xAxisKey) 
                || !Object.keys(_rows?.at(0) ?? {}).includes(yAxisKey)) return [];

			const groupedByXAxis = _.groupBy(_rows, xAxisKey);
			return Object.keys(groupedByXAxis).map((key) => {
				const rows = groupedByXAxis[key];
				const sum = rows.reduce((acc, row) => acc + +(row[yAxisKey] ?? 0), 0);
  
				return {
					[xAxisKey]: key,
					[yAxisKey]: sum ?? 0,
				};
			});

			
		}
		catch (error) {
			return [];
		}
	}, [ xAxisKey, yAxisKey, rows, ]);

	return (
		<Flex vertical style={{
			width: '100%',
			height: '100%',
			flex: 1,
			padding: 12,
			overflow: 'hidden',
		}}
		>
			<Typography.Title level={4}>{ title }</Typography.Title>
			<AutoSizer>
				{({ height, width, }) => (
					<Bar
						width={width}
						height={height}
						animate={false}
						data={data }
						margin={{ bottom: 50, }}
						keys={[ yAxisKey ?? '', ]}		
						indexBy={ xAxisKey ?? '' }
						padding={.3}
						valueScale={{ type: 'linear', }}
						colors={{ scheme: 'tableau10', }}
						colorBy='indexValue'
						axisTop={null}
						axisRight={null}
						enableGridX={false}
						enableGridY={true}
						enableLabel={true}
						labelTextColor={'white'}
						borderRadius={4}
					/>
				)}
			</AutoSizer>
			
		</Flex>
	);
}
